import { useMutation } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import type { CreateOrUpdateProviderRequest, ProviderResponse } from "./providersApi";
import { createProvider } from "./providersApi";

export const useCreateProvider = () => {
  const { enqueueSnackbar } = useSnackbar();

  const createProviderMutation = useMutation<ProviderResponse, unknown, CreateOrUpdateProviderRequest>({
    mutationFn: (v) => createProvider(v),
    onSuccess: (data) => {
      enqueueSnackbar(`Dostawca ${data.name} został utworzony`, { variant: "success" });
    },
    onError: (error) => {
      enqueueSnackbar(`Nie udało się stworzyć dostawcy. Powód: ${(error as Error).message}`, { variant: "error" });
    },
  });

  return { createProvider: (request: CreateOrUpdateProviderRequest) => createProviderMutation.mutateAsync(request) };
};
